import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "login-wrap" }
const _hoisted_2 = { class: "login-card" }
const _hoisted_3 = {
  key: 0,
  class: "login-err"
}

import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { NInput, NButton } from 'naive-ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const token = ref('')
const loading = ref(false)
const errMsg = ref('')

function saveToken(t: string) {
  localStorage.setItem('auth_token', t)
  const to = (route.query.redirect as string) || '/'
  router.replace(to)
}

onMounted(() => {
  const urlToken = route.query.token as string
  if (urlToken) {
    saveToken(urlToken)
    return
  }
  const saved = localStorage.getItem('auth_token')
  if (saved) {
    saveToken(saved)
  }
})

async function doLogin() {
  const t = token.value.trim()
  if (!t) {
    errMsg.value = '请输入口令'
    return
  }
  loading.value = true
  errMsg.value = ''
  // 用后端任意需要认证的接口验证 token
  try {
    const resp = await fetch(`${globalThis.location.origin}/api/Game/GetUserList?page=1&pageSize=1`, {
      headers: { 'X-Auth-Token': t, 'Content-Type': 'application/json' }
    })
    if (resp.status === 200) {
      saveToken(t)
    } else if (resp.status === 401) {
      errMsg.value = '口令错误，请重试'
    } else {
      saveToken(t) // 其他错误也先存着
    }
  } catch {
    saveToken(t) // 网络不通也先存着
  } finally {
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "login-title" }, "🔐 口令验证", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "login-desc" }, "请输入授权口令进入后台", -1)),
      _createVNode(_unref(NInput), {
        value: token.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((token).value = $event)),
        type: "password",
        "show-password-on": "click",
        placeholder: "输入口令...",
        size: "large",
        class: "login-input",
        onKeyup: _withKeys(doLogin, ["enter"])
      }, null, 8, ["value"]),
      _createVNode(_unref(NButton), {
        type: "primary",
        size: "large",
        block: "",
        loading: loading.value,
        onClick: doLogin,
        class: "login-btn"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" 验证 ")
        ])),
        _: 1
      }, 8, ["loading"]),
      (errMsg.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(errMsg.value), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})